import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { SharedModule } from 'src/app/shared.module';
import { WidgetsComponentsModule } from 'src/app/components/widgets/widgets-components.module';

import { TopbarComponent } from './topbar/topbar.component';
import { FooterComponent } from './footer/footer.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { AvatarModule } from 'ngx-avatar';
import { PipesModule } from 'src/app/pipes/pipes.module';

const COMPONENTS = [TopbarComponent, FooterComponent, SidebarComponent];

@NgModule({
  imports: [
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    WidgetsComponentsModule,
    AvatarModule,
    BsDropdownModule.forRoot(),
    PipesModule,
  ],
  declarations: [...COMPONENTS],
  exports: [...COMPONENTS],
})
export class LayoutModule {}
